module.exports = __webpack_public_path__ + "static/palettte1-6b4713028c8eae06d1891f9a3350394f.jpg";